<style lang="scss">
</style>

<template>
	<div>
		<Form
			v-for="(formData,index) in formList"
			:key="index"
			:label-width="120"
			ref="form"
			:model="formData"
			class="clearfix bg-fff shadow padding-right-20 margin-top-15"
		>
			<Col span="24">
				<header class="detail-title font-bold">
					{{formData|filterTitle}}
					<Icon
						v-if="(type!=='query'||status!=='review')&&formList.length>1"
						type="close"
						class="pull-right margin-top-10"
						style="cursor:pointer"
						@click.native="handleClear(index)"
					></Icon>
					<Button
						v-if="type==='query'"
						size="small"
						type="primary"
						class="pull-right margin-top-5 margin-left-10"
						@click.stop="getPacking(formData.transferNo)"
					>查看装箱</Button>
					<Button
						v-if="type==='query'"
						size="small"
						type="primary"
						class="pull-right margin-top-5"
						@click.stop="uploadDetail(formData.id)"
					>导出</Button>
				</header>
			</Col>
			<Col span="12">
				<FormItem prop="sourceOrderNos" label="来源采购单号" :rules="required">
					<span v-if="review">{{formData.sourceOrderNos}}</span>
					<Input v-else :value="formData.sourceOrderNos" readonly placeholder="点击可搜索选择采购单"></Input>
				</FormItem>
			</Col>
			<Col span="12" class="padding-left-10" v-if="!review">
				<vButton class="margin-right-15" theme="primary" @click="showBillData(index)">搜索</vButton>
				<vButton class="margin-right-15" theme="error" @click="clearBillData(index)">清空</vButton>
				<vButton theme="info" @click="handleUpload(index)">导入</vButton>
			</Col>
			<Col span="24" class="padding-20" v-if="type!=='query'">
				<Table :columns="columns" :data="formData.shipmentPlanOrderItems" size="small" border stripe></Table>
			</Col>
			<Col span="24">
				<Col span="12">
					<FormItem label="目的仓" prop="orgWarehouseId" :rules="issuper?requireBase:required">
						<span
							v-if="review&&!issuper"
						>{{formData.orgWarehouseId|transferText('%code%(%title%)',warehouseList)}}</span>
						<Select
							v-else
							v-model="formData.orgWarehouseId"
							filterable
							clearable
							@on-change="getAddress(formData,index,'warehouse')"
						>
							<Option
								v-for="item in warehouseList"
								:value="item.id"
								:key="item.id"
							>{{ item.code }}({{item.title}})</Option>
						</Select>
					</FormItem>
				</Col>
				<Col span="12" v-if="isTypeWarehouse(formData.orgWarehouseId,2)">
					<FormItem label="目的地址" prop="addressCode" :rules="issuper?requireBase:required">
						<span v-if="review&&!issuper">{{formData.addressCode}}</span>
						<Select
							v-else
							v-model="formData.addressCode"
							filterable
							clearable
							@on-change="getAddress(formData,index,'code')"
						>
							<Option
								v-if="formData.addressCode&&!(formData.wareHouseCodeList||[]).length"
								:value="formData.addressCode"
							>{{formData.addressCode}}</Option>
							<template v-else>
								<Option
									v-for="(item,index) in formData.wareHouseCodeList"
									:value="item"
									:key="index"
								>{{item}}</Option>
							</template>
						</Select>
					</FormItem>
				</Col>
			</Col>
			<Col span="12">
				<FormItem label="国家">
					<span>{{formData.country}}</span>
				</FormItem>
			</Col>
			<Col span="12">
				<FormItem label="州">
					<span>{{formData.state}}</span>
				</FormItem>
			</Col>
			<Col span="12">
				<FormItem label="城市">
					<span>{{formData.city}}</span>
				</FormItem>
			</Col>
			<Col span="12">
				<FormItem label="邮编">
					<span>{{formData.zipcode}}</span>
				</FormItem>
			</Col>
			<Col span="12">
				<FormItem label="地址">
					<span>{{formData.address}}</span>
				</FormItem>
			</Col>
			<Col span="12">
				<FormItem label="联系人">
					<span>{{formData.contactName}}</span>
				</FormItem>
			</Col>
			<Col span="12">
				<FormItem label="联系电话">
					<span>{{formData.contactPhone}}</span>
				</FormItem>
			</Col>
			<Col span="12" v-if="isTypeWarehouse(formData.orgWarehouseId,2)||onsiteWarehouseStatus[index]">
				<FormItem label="Shipment ID" prop="shipmentId" :rules="required">
					<span v-if="review">{{formData.shipmentId}}</span>
					<Input v-else v-model="formData.shipmentId"/>
				</FormItem>
			</Col>
			<Col span="12" v-if="isTypeWarehouse(formData.orgWarehouseId,2)">
				<FormItem label="Referrence  ID" prop="referrenceId" :rules="required">
					<span v-if="review">{{formData.referrenceId}}</span>
					<Input v-else v-model="formData.referrenceId"/>
				</FormItem>
			</Col>
			<Col span="12">
				<FormItem label="建仓时间" prop="buildWarehouseAt" :rules="required">
					<span v-if="review">{{formData.buildWarehouseAt}}</span>
					<DatePicker v-else v-model="formData.buildWarehouseAt" type="date" class="width-100per"></DatePicker>
				</FormItem>
			</Col>
			<Col span="12" v-if="review">
				<FormItem label="预计到货日期">
					<span>{{formData.estimateArrivalAt}}</span>
				</FormItem>
			</Col>
			<Col span="12" v-if="review">
				<FormItem label="到仓日期">
					<span>{{formData.actualArrivalAt}}</span>
				</FormItem>
			</Col>
			<Col span="24" class="padding-20" v-if="type==='query'">
				<Table
					:columns="columnsQuery"
					:data="formData.shipmentPlanOrderItems"
					size="small"
					border
					stripe
				></Table>
			</Col>
		</Form>
		<aside class="bg-fff padding-left-20" v-if="!review&&$parent.baseData.shipType!=0">
			<Button type="primary" class="width-15per" @click="add">添加子单据</Button>
		</aside>
		<footer class="bg-fff padding-20 text-right" v-if="!review">
			<Button type="primary" class="width-15per margin-right-15" @click="preStep">上一步</Button>
			<Button type="primary" class="width-15per" @click="nextStep">下一步</Button>
		</footer>
		<footer class="bg-fff padding-20 text-right" v-if="status==='review'&&type==='query'&&issuper">
			<Button type="primary" class="width-15per" @click="nextStep">保存</Button>
		</footer>
		<Modal
			v-if="!review"
			width="1000"
			title="来源采购单号"
			@on-cancel="showBilllist=false"
			@on-ok="getBillDataList($refs.billlist.checkedData)"
			v-model="showBilllist"
		>
			<compBilllist v-if="showBilllist" ref="billlist"/>
		</Modal>
		<Modal
			class="comson"
			width="1000"
			title="查看装箱"
			@on-cancel="showPacking=false"
			@on-ok="showPacking=false"
			v-model="showPacking"
		>
			<p
				v-if="packingNumber"
				class="margin-bottom-10"
			>总箱数:&nbsp;{{packingNumber.cartonQty}}&nbsp;&nbsp;装箱总重量:&nbsp;{{packingNumber.cartonTotalWeight}} kg&nbsp;&nbsp;装箱总体积:&nbsp;{{packingNumber.cartonTotalVolume}} m³</p>
			<compPacking v-if="showPacking" ref="packing" startUp :initFormData="{inboundPlanOrderNo}"/>
		</Modal>
		<div v-if="operate.show">
			<compDelModal @on-confirm="clearFormData" v-bind="operate" @on-close="operate={}"></compDelModal>
		</div>
		<Spin size="large" fix v-if="loading"></Spin>
	</div>
</template>

<script>
import { mapState,mapGetters } from 'vuex'
import compBilllist from './billlist'
import compPacking from './packing'
import compUpload from '@components/templates/upload'
import compDelModal from '@/components/boss/delModal'
import { HttpShipOBillDataList, HttpWareHouseCodeList, HttpPackingGetNumber } from '@/service/boss/shipment'
import { HttpAllotAddress } from '@/service/boss/dictionary'


export default {
	props: ['data', 'type', 'status', 'parentId'],
	components: {
		compBilllist,
		compPacking,
		compDelModal
	},
	data() {
		return {
			loading: false,
			showBilllist: false,
			showPacking: false,
			billList: [],
			issuper: this.$route.query.issuper == 1,
			operate: {

			},
			formList: [
				{
					// parentId: '',
					sourceOrderNos: '',
					orgWarehouseId: '',
					addressCode: '',
					country: '',
					city: '',
					zipcode: '',
					address: '',
					contactName: '',
					contactPhone: '',
					shipmentId: '',
					referrenceId: '',
					buildWarehouseAt: '',
					shipmentPlanOrderItems: [],
					_curbillIndex: 0,
				}
			],
			requireBase: [{
				required: true,
				message: "该信息不能为空,请填写"
			}],
			required: this.type !== 'query' ? [{
				required: true,
				message: "该信息不能为空,请填写"
			}] : null,
			packingNumber: '',
			inboundPlanOrderNo: '',
			onsiteWarehouseStatus: {},
		}
	},
	created() {
		if (this.data.length > 0) {
			this.formList = [...this.data];
		}
		this.formList.forEach((item, index) => {
			item.shipmentPlanOrderItems = item.shipmentPlanOrderItems || [];
			item.shipmentPlanOrderItems.forEach((val) => {
				val._curbillIndex = index;
			});
			this.$set(this.onsiteWarehouseStatus, index, this.isTypeWarehouse(item.orgWarehouseId, 4))

		});
	},
	filters: {
		filterTitle(formData) {
			const { transferNo, orderStatus } = formData,
				status = {
					establish: '已创建',
					submit: '已提交',
					confirm: '已确认',
					reject: '已驳回',
					shipment: '已发运',
					complete: '已完成',
					close: '已取消',
					delete: '已删除',
					draft: '草稿',
				};
			if (transferNo) {
				return `入库单${transferNo}（${status[orderStatus]}）`
			}
			return '选择发运数量及目的地'
		},
	},
	computed: {
		...mapState('boss', [ 'warehouseList']),
		...mapGetters('diction',['getNewProductList','getNewWarehouseIdList']),
		warehousesAll() {
			return this.warehouseList.filter(function (item) {
				return item.warehouseType !== 4
			})
		},
		review() {
			return this.status === 'review'
		},
		columns() {
			return [
				{
					title: 'ERP SKU',
					key: 'erpSku',
				},
				{
					title: '采购单号',
					key: 'sourceOrderNo',
				},
				{
					title: '待发运数量',
					key: 'estimateAmount',
				},
				{
					title: '计划发运数量',
					key: 'transferAmount',
					render: (h, { row, index }) => {
						const { _curbillIndex = 0, transferAmount, estimateAmount = 0, } = row;
						const items = this.formList[_curbillIndex].shipmentPlanOrderItems;
						const data = items[index] || {};
						return this.review ? h('span', transferAmount) : h('InputNumber', {
							props: {
								value: data.transferAmount || 0,
								min: 0,
								max: estimateAmount
							},
							on: {
								'input': (value) => {
									let val = this.handleAutoTransferAmount(data, [_curbillIndex, index]);
									if (val <= value) {
										value = val;
										this.$Message.warning(`当前可剩余发运数量为${value}`);
										this.$nextTick(() => {
											this.$set(items, index, { ...data, transferAmount: value });
											this.$set(row, 'transferAmount', value);
											this.$forceUpdate();
										})
									} else {
										items[index] = { ...data, transferAmount: value || 0 }
									}
								},
								'on-blur': () => {
									this.$nextTick(() => {
										if (!items[index].transferAmount) {
											this.$set(items, index, { ...data, transferAmount: 0 });
											this.$set(row, 'transferAmount', 0);
										}
									})
								}
							}
						})
					}
				},
				{
					title: '外箱尺寸(长*宽*高)',
					key: 'boxLength',
					render(h, { row }) {
						const { boxLength, boxWidth, boxHeight } = row;
						return <div>
							{boxLength}cm * {boxWidth}cm * {boxHeight}cm
                            </div>
					}
				},
				{
					title: '装箱入数',
					key: 'packedQty',
				},
				{
					title: '外箱毛重(G)',
					key: 'boxWeight',
				},
			]
		},
		columnsQuery() {
			return [
				{
					title: '#',
					type: 'index',
				},
				{
					title: 'ERP SKU',
					key: 'erpSku',
				},
				{
					title: '项目',
					key: 'lineId',
					render: (h, { row }) => {
						const id = row.lineId;
						const product = this.getNewProductList.filter((item) => {
							return id == item.value
						})[0] || {};
						return <span>{product.label}</span>
					},
				},
				{
					title: '采购单价',
					key: 'unitPrice',
				},

				{
					title: '采购币种',
					key: 'currency',
				},
				{
					title: '计划发运数量',
					key: 'transferAmount',
				},
				{
					title: '实际发运数量',
					key: 'actualTransferAmount',
				},
				{
					title: '接收数量（可售）',
					key: 'availableAmount',
				},
				{
					title: '接收数量（不可售）',
					key: 'noAvailableAmount',
				},
			]
		},

	},

	methods: {
		uploadDetail(id){
			this.handleWebfs(process.env.VUE_APP_APIURL_BOSS +'/api/v2/ShipmentPlan/export',{id:id},'download')
		},
		handleClear(index) {
			this.operate = {
				index,
				show: true,
				title: '删除',
				desc: '确认删除该子单据？'
			}
		},
		getPacking(inboundPlanOrderNo) {
			this.showPacking = true;
			this.inboundPlanOrderNo = inboundPlanOrderNo
			HttpPackingGetNumber({ inboundPlanOrderNo }).then(
				res => {
					this.packingNumber = res.data
				}, err => {
					this.errorMessage(err.message);
					this.loading = false;
				}
			)
		},
		handleUpload(index) {
			const formData = this.formList[index];
			if (!formData.sourceOrderNos) return this.$VMessage.warning('请先填写采购单单号');
			// console.log(formData)
			const data = {
				attrs: {
					data: {
						id: this.$parent.id,
						sourceOrderIds: formData.sourceOrderIds || formData.shipmentPlanOrderItems.map(function (item) { return item.sourceOrderId }).join(',')
					},
					action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/ShipmentPlan/importSourceOrder",
					name: "excelFile",
					download() {
						this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/ShipmentPlan/sourceOrderTemplate", {}, 'download')
					},
				},
				on: {
					'on-success': (res) => {
						this.$VModal.destroy();
						const data = res.data || [], sourceOrderNos = new Set(), sourceOrderIds = new Set();
						data.forEach(item => {
							item._curbillIndex = index;
							sourceOrderNos.add(item.sourceOrderNo);
							sourceOrderIds.add(item.sourceOrderId);
						});
						// const shipmentPlanOrderItems = this.initTransferAmount(data, index);
						this.$set(this.formList[index], 'shipmentPlanOrderItems', data);
						this.$set(this.formList[index], 'sourceOrderNos', [...sourceOrderNos].join(','));
						this.$set(this.formList[index], 'sourceOrderIds', [...sourceOrderIds]);
					},
					'on-cancel': () => {
						this.$VModal.destroy();
					}
				}
			}
			this.$VModal.default({
				title: "导入数据",
				width: 460,
				showFooter: false,
				render: (h, props) => {
					return h(compUpload, data)
				}
			})
		},
		showBillData(index) {
			this.showBilllist = true;
			this._curbillIndex = index;
		},
		clearBillData(index) {
			this.$set(this.formList[index], 'shipmentPlanOrderItems', []);
			this.$set(this.formList[index], 'sourceOrderNos', "");
		},
		clearFormData() {
			const formList = this.formList, index = this.operate.index;
			if (formList.length > 1) {
				formList.splice(index, 1)
			}
			formList.forEach((item, index) => {
				item._curbillIndex = index;
				(item.shipmentPlanOrderItems || []).forEach(val => {
					val._curbillIndex = index;
				})
			})
			this.operate = {};
		},
		//自动计算发运数量
		handleAutoTransferAmount(row = {}, axis) {
			const amountData = this.handleTransferAmount(axis),
				{ erpSku = "", sourceOrderNo = "", transferAmount = 0, estimateAmount = 0 } = row,
				data = amountData[erpSku + '=' + sourceOrderNo] || { transferAmount: 0 };
			// console.log(data)
			return estimateAmount - data.transferAmount;
		},
		handleTransferAmount(axis = []) {
			const amountData = {};
			this.formList.forEach((data, x) => {
				data.buildWarehouseAt = this.handleDateFormat(data.buildWarehouseAt, 'yyyy-mm-dd');
				if (axis && axis[0] === x) return;//针对一个table下erpSku + '=' + sourceOrderNo唯一性
				data.shipmentPlanOrderItems.forEach((item, y) => {
					// if (axis && axis[1] === y) return;
					//if (axis && axis[0] === x && axis[1] === y) return;针对从x,y唯一
					const { erpSku = "", sourceOrderNo = "", estimateAmount = 0, transferAmount = 0 } = item, key = erpSku + '=' + sourceOrderNo, obj = amountData[key];
					if (!obj) {
						amountData[key] = {
							erpSku,
							sourceOrderNo,
							estimateAmount,
							transferAmount,
							yAxis: y,
							xAxis: x,
						}
					} else {
						obj.transferAmount = obj.transferAmount + transferAmount
					}
				})
			});
			return amountData;
		},

		async nextStep() {
			const promises = this.$refs.form.map(async (ref) => {
				const valid = await ref.validate();
				return valid ? Promise.resolve(true) : Promise.reject(false);
			});
			const amountData = this.handleTransferAmount();
			for (let key of Object.keys(amountData)) {
				const item = amountData[key];
				if (item.transferAmount > item.estimateAmount) {
					return this.$Message.error('计划发运总数量不能大于待发运数量;');
				}
			}
			Promise.all(promises).then(posts => {
				const parent = this.$parent;
				parent.billData = this.formList;
				parent.submitChildBill();
			}).catch(err => {
				this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
			})
		},
		preStep() {
			this.$parent.status = 'base';
		},
		//某种类型仓库
		isTypeWarehouse(id, warehouseType) {
			return this.warehouseList.some(item => {
				return item.id == id && item.warehouseType == warehouseType;
			})
		},

		getAddress(data = {}, index, type) {
			this.formList[index].shipmentId = "";
			this.$nextTick(() => {
				const { orgWarehouseId, addressCode } = data, isAmazon = this.isTypeWarehouse(orgWarehouseId, 2);
				this.$set(this.onsiteWarehouseStatus, index, this.isTypeWarehouse(orgWarehouseId, 4));
				// console.log(this.onsiteWarehouseStatus)
				if (type === 'warehouse' && isAmazon) {
					this.getWHCodeList(orgWarehouseId, index);
					this.$set(this.formList, index, { ...data, country: '', zipcode: '', state: '', city: '', address: '', contactName: '', contactPhone: '', addressCode: '' })
					return;
				}
				const formData = isAmazon ? { warehouseId: orgWarehouseId, addressCode } : { warehouseId: orgWarehouseId }
				// this.loading = true;
				// if(!formData.addressCode){
				//     this.loading = false;
				// }else{
				this.loading = true;
				HttpAllotAddress(formData).then(res => {
					this.loading = false;
					const { country = '', city = '', postal = '', address = '', linkman = '', mobilePhone = '', state = '' } = res.data || {};
					this.$set(this.formList, index, { ...data, country, zipcode: postal, state, city, address, contactName: linkman, contactPhone: mobilePhone });
				}, err => {
					this.loading = false;
					this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
				});
				// }
			})
		},

		initTransferAmount(data = [], _curbillIndex) {
			const amountData = this.handleTransferAmount([_curbillIndex]);
			return data.map((item) => {
				const { erpSku = "", sourceOrderNo = "", estimateAmount = 0 } = item,
					transferAmount = estimateAmount - ((amountData[`${erpSku}=${sourceOrderNo}`] || {}).transferAmount || 0);
				return { ...item, _curbillIndex, transferAmount: transferAmount < 0 ? 0 : transferAmount }
			})
		},
		//采购单数据
		async getBillDataList(ids = []) {
			this.loading = true;
			HttpShipOBillDataList({
				sourceOrderIds: ids.join(','),
				parentId: this.$parent.id
			}).then(res => {
				this.loading = false;
				const data = res.data || [], _curbillIndex = this._curbillIndex, sourceOrderNos = new Set();
				data.forEach(item => {
					item._curbillIndex = _curbillIndex;
					sourceOrderNos.add(item.sourceOrderNo);
				});
				const shipmentPlanOrderItems = this.initTransferAmount(data, _curbillIndex);
				this.$set(this.formList[_curbillIndex], 'shipmentPlanOrderItems', shipmentPlanOrderItems);
				this.$set(this.formList[_curbillIndex], 'sourceOrderNos', [...sourceOrderNos].join(','));
				this.$set(this.formList[_curbillIndex], 'sourceOrderIds', ids);
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
			});
		},
		//仓库code list
		async getWHCodeList(data, index) {
			this.loading = true;
			HttpWareHouseCodeList({
				warehouseId: data
			}).then(res => {
				this.loading = false;
				this.$set(this.formList[index], 'wareHouseCodeList', res.data || []);
			}, err => {
				this.loading = false;
				this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
			});
		},

		async add() {
			let formList = this.formList,
				length = formList.length,
				sourceOrderIds = new Set();
			(formList[length - 1].shipmentPlanOrderItems || []).forEach((item) => {
				sourceOrderIds.add(item.sourceOrderId)
			})
			sourceOrderIds = [...sourceOrderIds];
			if (!sourceOrderIds.length) return;
			this._curbillIndex = length;
			formList.push({
				_curbillIndex: length,
				orgWarehouseId: '',
				addressCode: '',
				country: '',
				city: '',
				zipcode: '',
				address: '',
				contactName: '',
				contactPhone: '',
				shipmentId: '',
				referrenceId: '',
				buildWarehouseAt: '',
				shipmentPlanOrderItems: []
			});
			this.getBillDataList(sourceOrderIds)
		}
	},

}
</script>

